import React, { Component } from 'react'
import moment from 'moment'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Row, Col, Table, Icon, Button } from 'antd'
import { companies } from '@services/api'

import * as style from './style.scss'
import { right } from 'App/AdminPanel/Header/index.scss'

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
class List extends Component<any> {
    render() {
        const { list, loading, company } = this.props

        const columns = [
            {
                title: 'שם הפוליסה',
                key: 'name',
                width: 600,
                align: 'right',
                render: (_, record) => (
                    <span>
                        <span style={{ margin: '0.5rem 1rem', display: 'inline-block' }}>
                            <Icon type="edit" />
                        </span>
                        {record.name}
                    </span>
                )
            },
            {
                title: 'קטגוריה',
                align: 'right',
                key: 'category',
                width: 300,
                render: (_, record) => <span>{record.category_name}</span>
            },
            {
                title: 'עדכון אחרון',
                align: 'right',
                key: 'updated_at',
                width: 300,
                render: (_, record) => {
                    let date = '--'
                    if (record.updated_at) date = moment(record.updated_at).format('DD/MM/YYYY HH:mm')
                    return <span>{date}</span>
                }
            },
            {
                title: 'עודכן ע"י',
                align: 'right',
                key: 'updated_by',
                render: (_, record) => {
                    return <span>{record.updated_by}</span>
                }
            },
            {
                title: 'מזהה',
                align: 'right',
                key: 'id',
                render: (_, record) => <span>{record.id}</span>
            }
        ]
        return (
            <Row>
                <Col>
                    <div className="box">
                        <Table
                            className="center-table"
                            style={{ width: '100%' }}
                            rowKey="id"
                            loading={loading}
                            columns={columns}
                            rowClassName={() => style.user_row}
                            dataSource={list}
                            pagination={{
                                pageSize: 10
                            }}
                            onRow={record => {
                                return {
                                    onClick: () => {
                                        this.props.history.push(`/insurance/${company}/${record.id}`)
                                    }
                                }
                            }}
                        />
                    </div>
                </Col>
            </Row>
        )
    }
}

export default withRouter(List)
